/* Galleries - With GLightbox
/* ---------------------------------------------------------- */

import GLightbox from 'glightbox'
import 'glightbox/dist/css/glightbox.css'

function setupGallery (gallery, index) {
    const images = gallery.querySelectorAll('.kg-gallery-image')

    if (!images.length) {
        return null
    }
    const galleryId = `ghost-gallery-${index}`

    images.forEach((imageContainer) => {
        const image = imageContainer.querySelector('img')
        if (!image) {
            return
        }
        let link = imageContainer.querySelector('a')
        if (!link) {
            link = document.createElement('a')
            link.href = image.currentSrc || image.src
            imageContainer.insertBefore(link, image)
            link.appendChild(image)
        }
        link.classList.add('glightbox')
        link.dataset.gallery = galleryId
        link.dataset.type = 'image'

        /*
         * ALT
         */
        if (image.alt) {
            link.dataset.title = image.alt
            link.setAttribute(
                'aria-label',
                `View : ${image.alt}`
            )
        }

        /*
         * Caption
         */
        const caption = imageContainer.querySelector('figcaption')
        if (caption) {
            link.dataset.description = caption.innerHTML
        }

        /*
         * Responsive image
         */
        if (image.srcset) {
            link.dataset.srcset = image.srcset
        }
        if (image.sizes) {
            link.dataset.sizes = image.sizes
        }
    })

    return GLightbox({
        selector: `[data-gallery="${galleryId}"]`,

        touchNavigation: true,
        keyboardNavigation: true,

        loop: true,

        zoomable: true,
        draggable: true,

        openEffect: 'zoom',
        closeEffect: 'zoom',
        slideEffect: 'slide',

        closeOnOutsideClick: true,

        moreText: 'Load more',
        moreLength: 120,
    })
}

export default function setupGalleries () {
    const galleries = document.querySelectorAll('.kg-gallery-card')
    if (!galleries.length) {
        return []
    }
    return Array.from(galleries)
        .map((gallery, index) => {
            return setupGallery(gallery, index)
        })
        .filter(Boolean)
}
